import { __assign } from "tslib";
import React from 'react';
import { TEXT_TOOLS_TYPE } from '../../../plugins/plugin-text-tools/types';
var styleMap = {
    BOLD: {
        className: 'da-editor-bold',
        style: {
            fontWeight: 'bold',
        },
    },
    ITALIC: {
        className: 'da-editor-italic',
        style: {
            fontStyle: 'italic',
        },
    },
    UNDERLINE: {
        className: 'da-editor-underline',
        style: {
            textDecoration: 'underline',
        },
    },
    STRIKETHROUGH: {
        className: 'da-editor-strikethrough',
        style: {
            textDecoration: 'line-through',
        },
    },
};
var toStyles = function (customStyles, params) {
    var styles = {};
    var classNames = '';
    for (var _i = 0, customStyles_1 = customStyles; _i < customStyles_1.length; _i++) {
        var custom = customStyles_1[_i];
        // Handle dynamic styles
        if (custom.startsWith(TEXT_TOOLS_TYPE + "_COLOR")) {
            var color = custom.split('_').pop() || '';
            if (/^#[0-9A-F]{6}$/i.test(color)) {
                styles.color = "" + color;
            }
            continue;
        }
        // Handle the mapped styles
        if (styleMap.hasOwnProperty(custom)) {
            styles = __assign(__assign({}, styles), styleMap[custom].style);
            classNames += styleMap[custom].className;
        }
    }
    return { styles: styles, classNames: classNames };
};
// This is used by the viewer
var customStyleViewer = function (children, styleArray, params) {
    if (styleArray.length === 0) {
        return children;
    }
    var _a = toStyles(styleArray, params), styles = _a.styles, classNames = _a.classNames;
    return (React.createElement("span", { key: "style-" + params.key, style: styles, className: classNames }, children));
};
export default customStyleViewer;
//# sourceMappingURL=styleRenderer.js.map